import {Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'
import MainBtn from '../customTable/MainBtn'

export default function Tabs({
  active,
  setActive,
}: {
  active: number
  setActive: React.Dispatch<React.SetStateAction<number>>
}) {
  const {t} = useTranslation()
  const store = useSelector((state: RootState) => state.vender)

  // Payment methods tab removed (Phase 7) — Pay Connect lives under Payments menu.
  const tabs = [
    {
      name: t('general'),
      isRead: store.permissions && store.permissions.includes('general_read'),
    },
    {
      name: t('shapping'),
      isRead: store.permissions && store.permissions.includes('shipping_read'),
    },
    {
      name: t('order'),
      isRead: store.permissions && store.permissions.includes('orders_update'),
    },
    {
      name: t('socialLinks'),
      isRead: store.permissions && store.permissions.includes('social_read'),
    },
    {
      name: t('languages'),
      isRead: store.permissions && store.permissions.includes('languages_read'),
    },
    {
      name: t('seo'),
      isRead: store.permissions && store.permissions.includes('seo_read'),
    },
    {
      name: t('address'),
      isRead: store.permissions && store.permissions.includes('address_read'),
    },
    {
      name: t('tax'),
      isRead: store.permissions && store.permissions.includes('vendor_tax'),
    },
  ]

  return (
    <Stack sx={{overflowX: 'auto'}} p={'60px 0 20px 0'} gap='40px' direction={'row'}>
      {tabs.map((e, i) => (
        <React.Fragment key={e.name}>
          {e.isRead && (
            <Stack position={'relative'} width={'max-content'}>
              <MainBtn
                without={i === active ? false : true}
                handelSubmit={() => setActive(i)}
                width={'max-content'}
                text={e.name}
              />
            </Stack>
          )}
        </React.Fragment>
      ))}
      <Stack width={'20px'}></Stack>
    </Stack>
  )
}
